const article = {};

article.helpList = [
    'https://jd.wapg.cn/help/攻略/关于万品京选.md',
    'https://jd.wapg.cn/help/京东内购群常见问题解答/一、什么是京东内购，优惠券从哪里来？.md',
    'https://jd.wapg.cn/help/京东内购群常见问题解答/二、什么人适合参与京东内购？.md',
    'https://jd.wapg.cn/help/京东内购群常见问题解答/三、如何建群？.md',
    'https://jd.wapg.cn/help/京东内购群常见问题解答/四、购物过程中常见问题找谁咨询？.md',
    'https://jd.wapg.cn/help/京东内购群常见问题解答/五、如何使群内用户活跃起来？.md',
    'https://jd.wapg.cn/help/京东内购群常见问题解答/六、关于后台使用方法？.md',
    'https://jd.wapg.cn/help/京东内购群常见问题解答/七、关于订单佣金和售后服务？.md',
    'https://jd.wapg.cn/help/京东内购群常见问题解答/八、关于订单和佣金的一些术语：失效.md',
    'https://jd.wapg.cn/help/京东内购群常见问题解答/九、如何增加群里人数？.md',
    'https://jd.wapg.cn/help/京东内购群常见问题解答/十、如何发展下级代理商？.md',
    'https://jd.wapg.cn/help/京东内购群常见问题解答/十一、如何挑选正确的推广商品？.md',
    'https://jd.wapg.cn/help/京东内购群常见问题解答/十二、更多教程请在公众号里查看历史直播培训.md',
    'https://jd.wapg.cn/help/京东内购群常见问题解答/十三、京东违规订单处理规则.md',
];

article.guideList = [
    'https://jd.wapg.cn/help/攻略/关于万品京选.md',
    'https://jd.wapg.cn/help/京东内购群常见问题解答/一、什么是京东内购，优惠券从哪里来？.md',
    'https://jd.wapg.cn/help/京东内购群常见问题解答/二、什么人适合参与京东内购？.md',
    'https://jd.wapg.cn/help/京东内购群常见问题解答/三、如何建群？.md',
    'https://jd.wapg.cn/help/京东内购群常见问题解答/四、购物过程中常见问题找谁咨询？.md',
    'https://jd.wapg.cn/help/京东内购群常见问题解答/五、如何使群内用户活跃起来？.md',
    'https://jd.wapg.cn/help/京东内购群常见问题解答/六、关于后台使用方法？.md',
    'https://jd.wapg.cn/help/京东内购群常见问题解答/七、关于订单佣金和售后服务？.md',
    'https://jd.wapg.cn/help/京东内购群常见问题解答/八、关于订单和佣金的一些术语：失效.md',
    'https://jd.wapg.cn/help/京东内购群常见问题解答/九、如何增加群里人数？.md',
    'https://jd.wapg.cn/help/京东内购群常见问题解答/十、如何发展下级代理商？.md',
    'https://jd.wapg.cn/help/京东内购群常见问题解答/十一、如何挑选正确的推广商品？.md',
    'https://jd.wapg.cn/help/京东内购群常见问题解答/十二、更多教程请在公众号里查看历史直播培训.md',
    'https://jd.wapg.cn/help/京东内购群常见问题解答/十三、京东违规订单处理规则.md',
];

article.ruleList = [
    'https://jd.wapg.cn/help/制度/万品京选用户奖励机制.md'
];

export default article;